import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Components
import Header from '../../components/Header/index';
import Title from '../../components/Title/index';

// Images
import RfactorIcon from '../../assets/images/rfactorIcon.png';
import ArmaIcon from '../../assets/images/armaIcon.png';

// Firebase
import { db } from '../../utils/firebaseConfig';

// Material-ui
import {
    List, ListItem, ListItemText, ListItemIcon, ListItemSecondaryAction, IconButton, Tooltip, Fab,
    Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button, TextField, Snackbar
} from '@material-ui/core';
import { Folder, Delete, Edit, Add } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

// Context
import AuthContext from '../../Context/context';

import './style.css';

function CategoriasRfactor() {
    let params: any = useParams();
    let history = useHistory();
    const { isAdmin } = useContext(AuthContext);

    const [categorias, setCategorias] = useState<any>([]);
    const [categoria, setCategoria] = useState<any>({});
    const [novaCategoria, setNovaCategoria] = useState('');
    const [categoriaId, setCategoriaId] = useState('');

    // Alert's
    const [alert, setAlert] = useState('');

    const [openAlert, setShowAlert] = useState(false);

    const showAlert = () => setShowAlert(true);

    const hideAlert = () => setShowAlert(false);

    // Dialogs
    const [addDialog, setShowAdd] = useState(false);
    const [deleteDialog, setShowDelete] = useState(false);

    const showAdd = () => setShowAdd(true);
    const showDelete = () => setShowDelete(true);

    const hideAdd = () => setShowAdd(false);
    const hideDelete = () => setShowDelete(false);

    // Aviso Dialog
    const [aviso, setAviso] = useState('');
    const [avisoDialog, setShowAviso] = useState(false);

    const showAviso = () => setShowAviso(true);

    const hideAviso = () => setShowAviso(false);

    // Booleans e Validators
    const [addError, setAddErrorBoolean] = useState(false);
    const [addErrorText, setAddError] = useState('');
    const [editCategoria, setEditCategoria] = useState(false);

    useEffect(() => {
        GetCategorias();
    }, []);

    const GetCategorias = () => {
        let collection = '';

        if (params.jogo === 'rfactor')
            collection = 'CategoriasModsRfactor'
        else if (params.jogo === 'arma')
            collection = 'CategoriasModsArma'
        else {
            setAlert('Este armazenamento não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        db.collection(collection).onSnapshot(resp => {
            var cat = resp.docs.map((c: any) => {
                return {
                    id: c.id,
                    nome: c.data().nome,
                    qtdMods: c.data().qtdMods
                }
            })

            setCategorias(cat);
        })
    }

    // Adicionar Categoria
    const AddCategoria = () => {
        let collection = '';

        if (params.jogo === 'rfactor')
            collection = 'CategoriasModsRfactor'
        else if (params.jogo === 'arma')
            collection = 'CategoriasModsArma'
        else {
            setAlert('Este armazenamento não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        if (novaCategoria.length === 0) {
            setAddError('Preencha o campo de categoria.');
            return setAddErrorBoolean(true);
        }

        let found = categorias.find((cat: any) => cat.nome === novaCategoria);

        if (found !== undefined && found !== null) {
            setAddError('Esta categoria já existe.');
            return setAddErrorBoolean(true);
        }

        db.collection(collection).add({
            nome: novaCategoria,
            qtdMods: 0
        })
            .then(resp => {
                hideAdd();
            })
            .catch(err => {
                hideAdd();
                console.log('Houve um erro ao adicionar uma categoria.')
            })
        limparCampos();
    }

    const UpdateCategoria = async () => {
        let collection = '';
        let jogo = '';

        if (params.jogo === 'rfactor') {
            collection = 'CategoriasModsRfactor'
            jogo = 'RfactorModsLinks'
        }
        else if (params.jogo === 'arma') {
            collection = 'CategoriasModsArma'
            jogo = 'ArmaModsLinks'
        }
        else {
            setAlert('Este armazenamento não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        if (novaCategoria.length === 0) {
            setAddError('Preencha o campo de categoria.');
            return setAddErrorBoolean(true);
        }

        let found = categorias.find((cat: any) => cat.nome === novaCategoria);

        if (found !== undefined && found !== null) {
            setAddError('Esta categoria já existe.');
            return setAddErrorBoolean(true);
        }

        // Busca a categoria que será editada por id
        await db.collection(collection).doc(categoriaId).get()
            .then(resp => {
                if (resp.exists) {
                    var cat = {
                        id: resp.id,
                        nome: resp.data()?.nome,
                        qtdMods: resp.data()?.qtdMods
                    }

                    // Edita a categoria
                    db.collection(collection).doc(categoriaId).update({
                        nome: novaCategoria
                    })
                        .catch(err => {
                            setAlert('Houve um erro ao editar uma categoria.')
                            return showAlert();
                        })

                    // Busca todos os mods que tenham essa mesma categoria
                    db.collection(jogo).where('categoria', '==', cat.nome).get()
                        .then(resp => {
                            let mds = resp.docs.map((m: any) => {
                                return {
                                    id: m.id,
                                }
                            })

                            // Faz um forEach para modificar a categoria dos mods encontrados
                            mds.forEach((m: any) => {
                                // Edita o mod por id, alterando para a categoria editada
                                db.collection(jogo).doc(m.id).update({
                                    categoria: novaCategoria
                                })
                                    .catch(err => {
                                        setAlert('Houve um erro ao editar a categoria alterada na coleção de mods.')
                                        return showAlert();
                                    })
                            })
                        })
                }
            })
            .catch(err => {
                setAlert('Houve algum erro no processo de edição da categoria.')
                return showAlert();
            })
        hideAdd();
        setAddError('');
        setNovaCategoria('');
        setCategoriaId('');
    }

    const DeleteCategoria = () => {
        let collection = '';

        if (params.jogo === 'rfactor') {
            collection = 'CategoriasModsRfactor'
        }
        else if (params.jogo === 'arma') {
            collection = 'CategoriasModsArma'
        }
        else {
            setAlert('Este armazenamento não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        if (categoria.qtdMods > 0) {
            hideDelete();
            setAviso(`Você não pode deletar a categoria "${categoria.nome}" pois ela ainda contêm ${categoria.qtdMods} mod(s) armazenados.`);
            return showAviso();
        }

        db.collection(collection).doc(categoriaId).delete()
            .then(resp => {
                hideDelete();
                // Atualiza a página para não conflitar dados excluidos com o snapshot da página mods
                window.location.reload();
            })
            .catch(err => {
                hideDelete();
                console.log('Houve um erro ao deletar uma categoria.')
            })
        limparCampos();
    }

    const limparCampos = () => {
        setAddError('');
        setNovaCategoria('');
        setCategoriaId('');
        setAddErrorBoolean(false);
        setEditCategoria(false);
    }

    return (
        <div>
            <Header />
            {
                params.jogo === 'rfactor' &&
                <Title img={RfactorIcon} title='Categoria de Mods rFactor 2' />
            }
            {
                params.jogo === 'arma' &&
                <Title img={ArmaIcon} title='Categoria de Mods Arma 2' />
            }

            {
                // Apenas irá renderizar os campos caso os paramêtros sejam válidos (arma ou rfactor)
                (params.jogo === 'rfactor' || params.jogo === 'arma') &&
                <div className="list-categorias">
                    {
                        categorias.length === 0 && <p> Não há categorias cadastradas </p>
                    }
                    <List style={{ maxHeight: 500, overflow: 'auto' }} >
                        {
                            categorias.map((cat: any) => {
                                return (
                                    <ListItem button className="list-categorias-item" onClick={() => {
                                        history.push(`/mods/${params.jogo}/${cat.id}`);
                                    }}>
                                        <ListItemIcon>
                                            <Folder />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={cat.nome}
                                            secondary={`Quantidade de mods: ${cat.qtdMods}`}
                                        />
                                        {
                                            isAdmin &&
                                            <ListItemSecondaryAction>
                                                <Tooltip title="Delete" onClick={() => {
                                                    setCategoria(cat);
                                                    setCategoriaId(cat.id);
                                                    showDelete();
                                                }} >
                                                    <IconButton >
                                                        <Delete />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Editar" onClick={() => {
                                                    setNovaCategoria(cat.nome);
                                                    setCategoriaId(cat.id);
                                                    setEditCategoria(true);
                                                    showAdd();
                                                }}>
                                                    <IconButton >
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                            </ListItemSecondaryAction>
                                        }
                                    </ListItem>
                                )
                            })
                        }
                    </List>
                    {
                        isAdmin &&
                        <div>
                            <hr />
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Tooltip title="Adicionar nova Categoria" onClick={() => {
                                    showAdd();
                                }}>
                                    <Fab color="inherit">
                                        <Add />
                                    </Fab>
                                </Tooltip>
                            </div>
                        </div>
                    }
                </div>
            }

            {
                (params.jogo === 'rfactor' || params.jogo === 'arma') && isAdmin &&
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '2em 0' }}>
                        <Button
                            id="btn-padrao"
                            variant="contained"
                            color="default"
                            //startIcon={<Unarchive />}
                            onClick={() => {
                                history.push(`/config/mods-ativos/${params.jogo}`);
                            }}
                        >
                            Configurar Mods Ativos
                        </Button>
                    </div>
                </div>
            }

            <Snackbar open={openAlert} autoHideDuration={12000} onClose={hideAlert}>
                <Alert onClose={hideAlert} severity="error" variant="filled">
                    {alert}
                </Alert>
            </Snackbar>

            {/* Modal para Adicionar Categoria */}
            <Dialog open={addDialog} aria-labelledby="form-dialog-title" onClose={() => {
                hideAdd();
                limparCampos();
            }}>
                <DialogTitle id="form-dialog-title">{editCategoria ? 'Editar' : 'Adicionar nova'} categoria</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Para {editCategoria ? 'editar uma' : 'adicionar uma nova'} categoria, complete o campo abaixo.
                    </DialogContentText>

                    <TextField
                        error={addError}
                        helperText={addErrorText}
                        value={novaCategoria}
                        autoFocus
                        margin="dense"
                        id="categoria"
                        label="Nova Categoria"
                        type="text"
                        fullWidth
                        onChange={e => setNovaCategoria(e.target.value)}
                    />

                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        hideAdd();
                        limparCampos();
                    }} >
                        Fechar
                    </Button>
                    <Button color="primary" onClick={() => {
                        editCategoria ? UpdateCategoria() : AddCategoria();
                    }}>
                        {editCategoria ? 'Salvar' : 'Adicionar'}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* FIM do Modal para Adicionar / Editar Categoria */}

            {/* Modal para Adicionar Categoria */}
            <Dialog open={deleteDialog} aria-labelledby="form-dialog-title2" onClose={() => {
                hideDelete();
                limparCampos();
            }}>
                <DialogTitle id="form-dialog-title2" >Deletar Categoria</DialogTitle>
                <DialogContent>
                    <DialogContentText color="error">
                        Você tem certeza que deseja deletar a categoria "{categoria.nome}"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        hideDelete();
                        limparCampos();
                    }} >
                        Cancelar
                    </Button>
                    <Button color="primary" onClick={() => {
                        DeleteCategoria();
                    }}>
                        Deletar
                    </Button>
                </DialogActions>
            </Dialog>
            {/* FIM do Modal para Adicionar Categoria */}

            {/* Modal de aviso */}
            <Dialog open={avisoDialog} aria-labelledby="modal-aviso" onClose={() => {
                hideAviso();
                setAviso('');
            }}>
                <DialogTitle id="modal-aviso" >Aviso</DialogTitle>
                <DialogContent>
                    <DialogContentText color="primary">
                        {aviso}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        hideAviso();
                        setAviso('');
                    }} >
                        Fechar
                </Button>
                </DialogActions>
            </Dialog>
            {/* FIM do Modal de aviso */}
        </div>
    );
}

export default CategoriasRfactor;